import { render, staticRenderFns } from "./model.vue?vue&type=template&id=77c53dc0&scoped=true&"
import script from "./model.vue?vue&type=script&lang=js&"
export * from "./model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c53dc0",
  null
  
)

export default component.exports